import '../../stylesheets/App.css';
//import '../../stylesheets/PopupRegister.css';
import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import Table from './Table';
import Search from './Search';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMagnifyingGlass, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { apiCall } from '../../helpers/apiCallConfiguration';


library.add(faPlus, faMagnifyingGlass); // Agrega los iconos que deseas utilizar

function Dashboard(props) {

    
    let [action, setAction] = useState('detail');
    let [element, setElement] = useState(0);
    let [keyword, setKeyword] = useState('');
    let [actualizar, setActualizar] = useState(0);
    let [filtroNivel, setFiltroNivel] = useState('');
    let [filtroNivelDesc, setFiltroNivelDesc] = useState('');
    let [niveles, setNiveles] = useState([]);
    let [filtroEstadoVenta, setFiltroEstadoVenta] = useState('activas');
    let navigate = useNavigate();

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }

    const updateStates = (action, item) => {
        setAction(action);
        setElement(item);
   }

   useEffect(()=>{
        if(!localStorage.getItem("user-info")){
            navigate('/login');
        }
        if(props.object === 'clientes'){
            apiCall(process.env.REACT_APP_API_BASE_URL + '/clientes/niveles/list/', (data) => setNiveles(data.data));
        }
    }, []);

    const handleNivelChange = (e) => {
        const val = e.target.value;
        setFiltroNivel(val);
        if(val === ''){
            setFiltroNivelDesc('');
        } else {
            const niv = niveles.find(n => n.idNivel == val);
            setFiltroNivelDesc(niv ? niv.descripcion : '');
        }
    };

    return (
        <>
            <div className="container my-5">

                <h1 className="general-subtitle text-center my-4">{props.object=='pagosaproveedores'?'pagos a proveedores':props.object=='refpagos'?'pagos de refinanciamientos':props.object}</h1>
                <div className="col-12 m-auto border rounded border-dark-blue p-4">
                    <div className="row">
                        <div className="col-12 col-sm-6 col-lg-3">
                            <a href="" className="btn rounded-pill btn-dark col-12 mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={()=>updateStates('Registrar', null)}>
                                <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </a>
                        </div>
                        {props.object=='eventos'?
                        <div className="col-12 col-sm-6 col-lg-3">
                            <a href="" className="btn rounded-pill btn-dark col-12 mb-2" onClick={()=>navigate('/mis-tareas')}>
                                <FontAwesomeIcon icon={faMagnifyingGlass} /> Ver mis tareas
                            </a>
                        </div>:''}
                    </div>
                    {props.object!='margenes'?<Search keyword={keyword} setKeyword={setKeyword}/>:''}
                    {props.object==='clientes'?
                    <div className="row mt-2 mb-2">
                        <div className="col-12 col-sm-6 col-lg-3">
                            <select className="form-select" value={filtroNivel} onChange={handleNivelChange}>
                                <option value="">Todos los niveles</option>
                                {niveles.map((n, i) => (
                                    <option key={i} value={n.idNivel}>{n.descripcion}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    :''}
                    {props.object==='ventas'?
                    <div className="row mt-2 mb-2">
                        <div className="col-12 col-sm-6 col-lg-3">
                            <select className="form-select" value={filtroEstadoVenta} onChange={e => setFiltroEstadoVenta(e.target.value)}>
                                <option value="activas">Ventas activas</option>
                                <option value="refinanciadas">Ventas refinanciadas</option>
                                <option value="perdidas">Ventas perdidas</option>
                                <option value="todas">Todas las ventas</option>
                            </select>
                        </div>
                    </div>
                    :''}
                    <Table object={props.object} action={action} setAction={setAction} element={element} setElement={setElement} keyword={keyword} actualizar={actualizar} setActualizar={setActualizar} filtroNivel={filtroNivel} filtroNivelDesc={filtroNivelDesc} filtroEstadoVenta={filtroEstadoVenta}/>
                </div>
            </div>
            

        </>
    );
}

export default Dashboard;